import React, { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContentText from '@mui/material/DialogContentText';
import Minimize from '@mui/icons-material/Minimize';
import Toolbar from '@mui/material/Toolbar';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import OpenInFull from '@mui/icons-material/OpenInFull';

function PaperComponent(props) {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#error-log-dialog-toolbar"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper ref={nodeRef} {...props} />
        </Draggable>
    );
}

const ErrorLogEntryDialog = ({ title, message, onClose }) => {
    const [isFullScreen, setIsFullScreen] = useState(false);

    const handleToggleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
    };

    return (
        <Dialog
            fullScreen={isFullScreen}
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            scroll={"paper"}
            open={true}
            fullWidth
            maxWidth='md'
            PaperComponent={PaperComponent}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)", // Darker backdrop
                },
            }}
        >
            <Toolbar sx={{ m: 0, p: 0, display: 'flex' }} id="error-log-dialog-toolbar">
                <DialogTitle id="error-dialog-title">
                    Error Details
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <IconButton
                    onClick={handleToggleFullScreen}
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 40,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    {isFullScreen ? <Minimize /> : <OpenInFull />}
                </IconButton>
            </Toolbar>
            <DialogContent sx={{
                m: 0,
                p: 0,
                paddingLeft: '20px',
                paddingRight: '20px',
                height: '60vh',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <DialogContentText id="error-dialog-description">
                    {title}
                </DialogContentText>
                <TextField multiline value={message} readOnly={true} sx={{ width: '100%' }} />
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onClose}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorLogEntryDialog;
